// extracted by css-extract-rspack-plugin
export default {"preview":"rpOOJ","oneLine":"ijrkq"};